<template>
  <v-icon class="mr-1" @click="$emit('click')">search</v-icon>
</template>

<script>
export default {
  data () {
    return {
      
    }
  }
}
</script>